module.exports = __webpack_public_path__ + "img/group_leaves.2a61b7fd.png";